export default __webpack_public_path__ + "static/media/cirun-logo.443fccb4.svg";